export class EtsError extends Error {
  constructor(message: string, ...params) {
    super(...params);
    this.name = 'EtsError';
    this.message = message;
  }
}
